module.exports = __webpack_public_path__ + "staticVue/img/loginBgLogo.27df2753.png";